import React, { useEffect, useState } from 'react';

import MultiStepDialog from 'components/Dialog/MultiStepDialog';

import ImportFileMappingContainer from 'app/components/ImportFileDialog/ImportFileMappingContainer/ImportFileMappingContainer';
import ImportQuotasFileUpload from 'app/components/ImportQuotasDialog/ImportQuotasFileUpload/ImportQuotasFileUpload';

import { useData } from 'app/contexts/dataProvider';

import { FileTypeEnum } from 'app/graphql/generated/graphqlApolloTypes';

import { formatMessage } from 'utils/messages/utils';

interface ImportQuotasDialogProps {
  onClose: () => void;
}

const ImportQuotasDialog: React.FC<ImportQuotasDialogProps> = ({ onClose }: ImportQuotasDialogProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dataMatchingRequired, setDataMatchingRequired] = useState<boolean>(false);

  const { resetFileUploadValues } = useData();

  useEffect(() => {
    resetFileUploadValues();
    return () => {
      setDataMatchingRequired(false);
    };
  }, []);

  const onNext = () => {
    setCurrentIndex(currentIndex + 1);
  };

  const renderPages = () => {
    let pages = [
      <ImportQuotasFileUpload
        onNext={onNext}
        dataMatchingRequired={dataMatchingRequired}
        setDataMatchingRequired={setDataMatchingRequired}
        onClose={onClose}
      />
    ];
    if (dataMatchingRequired) {
      pages = [...pages, <ImportFileMappingContainer fileType={FileTypeEnum.TerritoryQuota} onClose={onClose} />];
    }
    return pages;
  };

  const renderProps = () => {
    if (currentIndex === 0) {
      return { title: formatMessage('IMPORT_QUOTAS') };
    }
    return {
      title: formatMessage('MATCH_FIELDS_TITLE')
    };
  };

  return (
    <MultiStepDialog
      data-testid="add-new-territory-dialog"
      isOpen
      currentIndex={currentIndex}
      setCurrentIndex={setCurrentIndex}
      pages={renderPages()}
      showDialogFooter={false}
      {...renderProps()}
    />
  );
};

export default ImportQuotasDialog;
